// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__YyuUv","reportBodyText":"style__reportBodyText__KcN89"};